import { EN_US_KICORE } from './en_US/LC_MESSAGES/EN_US_KICORE.mo.js';
import { FR_FR_KICORE } from './fr_FR/LC_MESSAGES/FR_FR_KICORE.mo.js';
import { DE_DE_KICORE } from './de_DE/LC_MESSAGES/DE_DE_KICORE.mo.js';
import { PT_PT_KICORE } from './pt_PT/LC_MESSAGES/PT_PT_KICORE.mo.js';
import { IT_IT_KICORE } from './it_IT/LC_MESSAGES/IT_IT_KICORE.mo.js';

/**
 * Búsqueda en los catálogos, sin React de por medio.
 *
 * `Locale` (locale.context.jsx) delega aquí, así que hay una sola implementación:
 * los componentes la usan a través de `lang.handle()` y el código que vive fuera
 * del árbol de React —interceptores, baseQuery, modales imperativos— puede
 * importar `translate` directamente.
 */
const translations = {
  en: EN_US_KICORE,
  fr: FR_FR_KICORE,
  de: DE_DE_KICORE,
  pt: PT_PT_KICORE,
  it: IT_IT_KICORE
};

/**
 * Idioma activo.
 */
export const getLangCode = () => localStorage.getItem('langCode') || 'en';

/**
 * Traduce un literal en español. Sin catálogo o sin entrada,
 * devuelve el original, que ya está en español.
 */
export const translate = (s, langCode = getLangCode()) =>
  translations[langCode]?.catalog[s] ?? s;
